import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Commands, Results } from '@local/client-contracts';

export type RadiusRichTextElement = { item: Results.RichTextElement; radiusType?: RadiusType };
export type RadiusType = 'top' | 'bottom' | 'full' | 'none';
@Component({
  selector: 'result-rich-text-block',
  templateUrl: './result-rich-text-block.component.html',
  styleUrls: ['./result-rich-text-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultRichTextBlockComponent {
  private _model: Results.RichTextBlock;
  elements: RadiusRichTextElement[] = [];

  @Input() highlights: Array<string>;
  @Input() set model(val: Results.RichTextBlock) {
    this._model = val;
    this.initElements();
  }
  @Output() invoke = new EventEmitter<Commands.Command>();
  
  get model(): Results.RichTextBlock {
    return this._model;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  private initElements() {
    const borderArr: boolean[] = this.model.elements.map((item, index) => {
      return this.getBorder(index);
    });

    this.elements = this.model.elements.map((item, index) => {
      return {
        item,
        radiusType: this.getRadiusType(borderArr[index - 1], borderArr[index], borderArr[index + 1]),
      };
    });
    this.cdr.markForCheck();
  }

  private getRadiusType(prevItemBolder: boolean, itemBolder: boolean, nextItemBolder: boolean): RadiusType {
    if (!itemBolder) return;
    if (!prevItemBolder && !nextItemBolder) return 'full';
    if (prevItemBolder && nextItemBolder) return 'none';
    if (prevItemBolder) return 'bottom';
    return 'top';
  }

  private getBorder(index: number): boolean {
    return !!this.model.elements[index].border || this.model.elements[index].type === 'rich_text_quote';
  }
}
